import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { TTP_COMMUNE_API, ttpCommuneUrl } from 'SharedDir/backend/endpoints/ttp-commune';
import {
  CommuneBare,
  CommuneCreate,
  CommuneFull,
  CommuneUpdate,
} from 'SharedDir/declarations/ttp-commune';

export class CommuneApiClass extends SimpleApi<
  CommuneFull,
  CommuneCreate,
  CommuneUpdate,
  CommuneBare
> {
  constructor() {
    super(ttpCommuneUrl);
  }

  protected readonly endpoints = TTP_COMMUNE_API;

  /**
   * Запрашиваем Общину по идентификатору
   *
   * @param id
   */
  public async get(id: string | number) {
    const endpoint = this.getSingleEndpoint(id);
    const { data } = (await http(endpoint)) as AxiosResponse<CommuneFull>;

    if (data.contactInfo === null) {
      data.contactInfo = {
        addresses: [],
        emails: [],
        phones: [],
      };
    }

    return data;
  }

  public async exclude(id: string | number, data) {
    const endpoint = this.endpoints.EXCLUDE(id);
    const { data: responseData } = await http({ ...endpoint, data });

    return responseData;
  }
}
